import React from 'react'
import { EditableDropdownCell, EditCellProps, EditCellState } from 'generic/editCell'
import { preventDefaultThen } from 'components/link/component'
import { ClickOutside } from 'components/click-outside/component'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export interface BlastActionsCellProps extends EditCellProps {
  canPreview?: boolean,
  canSchedule?: boolean,
  canSendNow?: boolean,
  previewLabel?: string,
  scheduleLabel?: string,
  sendNowLabel?: string,
  onPreview?: (dataItem: any) => void,
  onSchedule?: (dataItem: any) => void,
  onSendNow?: (dataItem: any) => void,
}

interface BlastActionsCellState extends EditCellState {
  showSendNowConfirmation: boolean,
}

export class BlastActionsCell extends EditableDropdownCell<BlastActionsCellProps, BlastActionsCellState> {

  constructor(props: BlastActionsCellProps) {
    super(props)
    this.state = {
      ...this.state,
      showSendNowConfirmation: false,
    }
  }

  private isSubjectAndPreviewFilled(): boolean {
    const blast = this.props.dataItem
    const subjectObj = blast.subject

    if (!subjectObj) {
      return false
    }

    const hasContent = subjectObj.content && subjectObj.content.trim().length > 0
    const hasPreview = subjectObj.preview && subjectObj.preview.trim().length > 0

    return hasContent && hasPreview
  }

  public render() {
    const canScheduleOrSend = this.isSubjectAndPreviewFilled()

    return (
      <td className="edit-cell">
        {this.renderSendNowConfirmationModal()}
        <div className="dropdown grid-clickable">
          <div onClick={() => this.setState({ drop: !this.state.drop })}>
            <div className="little-circle"></div>
            <div className="little-circle"></div>
            <div className="little-circle"></div>
          </div>
          {!!this.state.drop && (
            <ClickOutside handleClickOutside={() => this.setState({ drop: !this.state.drop })}>
              <div className="dropdown-content" onClick={(e) => e.stopPropagation()}>
                {this.props.canPreview && (
                  <a onClick={preventDefaultThen((e) => this.handlePreview(e))}>
                    {this.props.previewLabel || 'Preview'}
                  </a>
                )}
                {this.props.canSchedule && (
                  <a
                    onClick={canScheduleOrSend ? preventDefaultThen((e) => this.handleSchedule(e)) : undefined}
                    className={canScheduleOrSend ? 'blast-action-enabled' : 'blast-action-disabled'}
                  >
                    {this.props.scheduleLabel || 'Schedule'}
                  </a>
                )}
                {this.props.canSendNow && (
                  <a
                    onClick={canScheduleOrSend ? preventDefaultThen((e) => this.handleSendNowClick(e)) : undefined}
                    className={canScheduleOrSend ? 'blast-action-enabled' : 'blast-action-disabled'}
                  >
                    {this.props.sendNowLabel || 'Send Now'}
                  </a>
                )}
              </div>
            </ClickOutside>
          )}
        </div>
      </td>
    )
  }

  private renderSendNowConfirmationModal(): JSX.Element {
    return (
      <Modal
        isOpen={this.state.showSendNowConfirmation}
        className="archive-confirmation-modal"
        size="lg"
        fade={false}
        centered={true}
      >
        <ModalHeader>Send Blast Now</ModalHeader>
        <ModalBody className="archive-confirmation-modal-body">
          <div>
            <h4>Are You Sure?</h4>
            <div>
              You are about to send blast <b>{this.props.dataItem.name}</b> immediately. This action cannot be undone. Would you like to proceed?
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.onConfirmSendNow}>
            Yes
          </Button>
          <Button onClick={this.onCancelSendNow}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private handlePreview(event: any) {
    if (this.props.onPreview) {
      this.props.onPreview(this.props.dataItem)
    }
    this.setState({ drop: !this.state.drop })
  }

  private handleSchedule(event: any) {
    if (this.props.onSchedule) {
      this.props.onSchedule(this.props.dataItem)
    }
    this.setState({ drop: !this.state.drop })
  }

  private handleSendNowClick = (event: any) => {
    this.setState({
      drop: false,
      showSendNowConfirmation: true
    })
  }

  private onCancelSendNow = () => {
    this.setState({ showSendNowConfirmation: false })
  }

  private onConfirmSendNow = () => {
    this.setState({ showSendNowConfirmation: false })
    if (this.props.onSendNow) {
      this.props.onSendNow(this.props.dataItem)
    }
  }
}
